import DashboardGerenciamento from '@/views/gerenciamento/DashboardGerenciamento';
import ProgramacaoMapeamento from '@/views/gerenciamento/ProgramacaoMapeamento';
import ProgramacaoDiagnostico from '@/views/gerenciamento/ProgramacaoDiagnostico';
import DispensaDiagnostico from '@/views/gerenciamento/DispensaDiagnostico';
import NormalizacaoComportamento from '@/views/gerenciamento/NormalizacaoComportamento';
import NormalizacaoResponsabilidade from '@/views/gerenciamento/NormalizacaoResponsabilidade';

const GerenciamentoRoutes = [
  {
    path: '/gerenciamento',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Gerenciamento' },
      ],
      requiresAuth: true,
    },
    name: 'DashboardGerenciamento',
    component: DashboardGerenciamento,
  },
  {
    path: '/gerenciamento/programacao-mapeamento',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Gerenciamento', href: '/gerenciamento' },
        { position: 3, text: 'Programação do Mapeamento' },
      ],
      requiresAuth: true,
    },
    name: 'ProgramacaoMapeamento',
    component: ProgramacaoMapeamento,
  },
  {
    path: '/gerenciamento/programacao-diagnostico',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Gerenciamento', href: '/gerenciamento' },
        { position: 3, text: 'Programação do Diagnóstico' },
      ],
      requiresAuth: true,
    },
    name: 'ProgramacaoDiagnostico',
    component: ProgramacaoDiagnostico,
  },
  {
    path: '/gerenciamento/dispensa-diagnostico',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Gerenciamento', href: '/gerenciamento' },
        { position: 3, text: 'Gerenciamento de Dispensas' },
      ],
      requiresAuth: true,
    },
    name: 'DispensaDiagnostico',
    component: DispensaDiagnostico,
  },
  {
    path: '/gerenciamento/normalizacao-comportamento',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Gerenciamento', href: '/gerenciamento' },
        { position: 3, text: 'Normalização Comportamental' },
      ],
      requiresAuth: true,
    },
    name: 'NormalizacaoComportamento',
    component: NormalizacaoComportamento,
  },
  {
    path: '/gerenciamento/normalizacao-responsabilidade',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Gerenciamento', href: '/gerenciamento' },
        { position: 3, text: 'Normalização das Competências Técnicas' },
      ],
      requiresAuth: true,
    },
    name: 'NormalizacaoResponsabilidade',
    component: NormalizacaoResponsabilidade,
    props: true,
  },
  {
    path: '/gerenciamento/consolidacao-responsabilidade',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Gerenciamento', href: '/gerenciamento' },
        { position: 3, text: 'Consolidação das Competências Técnicas' },
      ],
      requiresAuth: true,
    },
    name: 'ConsolidacaoResponsabilidade',
    component: NormalizacaoResponsabilidade,
    props: true,
  },
];

export default GerenciamentoRoutes;
